export const VehicleInfo = {
  yearList,
  findMakeId,
  findMake,
  EngineClassList,
};

function findMakeId(makeName, makeList) {
  let retMakeId = 0;
  let makeInfo = makeList.filter((x) => x.label === makeName);
  if (makeInfo[0] !== undefined) {
    retMakeId = makeInfo[0].code;
  }
  return retMakeId;
}

function findMake(makeCode, makeList) {
  let retMake = "";
  let makeInfo = makeList.filter((x) => x.code === makeCode);
  if (makeInfo[0] !== undefined) {
    retMake = makeInfo[0].label;
  }
  return retMake;
}

//Previous Code Needed in Future

// function yearList() {
//   let yearArray = [];
//   for (let i = new Date().getMonth() > 5 ? -1 : 0; i <= 70; i++) {
//     let newObj = {
//       label: (new Date().getFullYear() - i).toString(),
//       code: (new Date().getFullYear() - i).toString(),
//     };
//     yearArray.push(newObj);
//   }
//   return yearArray;
// }

//Previous Code Needed in Future

function yearList(isISA = false) {
  let yearArray = [];
  const currentYear = new Date().getFullYear();
  const monthOffset = new Date().getMonth() > 5 ? -1 : 0;

  for (let i = monthOffset; i <= 70; i++) {
    const year = currentYear - i;

    if (isISA && year < 1996) break;

    yearArray.push({
      label: year.toString(),
      code: year.toString(),
    });
  }

  return yearArray;
}


function EngineClassList() {
  return [
    { code: 1, label: "Gasoline or Diesel" },
    { code: 2, label: "Hybrid" },
    { code: 3, label: "Electric" },
    { code: 4, label: "Natural Gas" },
  ];
}


